import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoArquivo } from 'src/app/models/enum';
import { Fornecedor } from 'src/app/models/fornecedor';
import { PedidoAnexo } from 'src/app/models/pedido-anexo';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { EnumService } from 'src/app/services/enum.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoAnexoService } from 'src/app/services/pedido-anexo.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { Familia } from 'src/app/models/produto';
import { Categoria } from '../../models/categoria';
import { CategoriaService } from '../../services/categoria.service';

@Component({
  selector: 'app-atualizar-produtos-modal',
  templateUrl: './atualizar-produtos-modal.component.html',
  styleUrls: ['./atualizar-produtos-modal.component.scss']
})
export class AtualizarProdutosModalComponent implements OnInit {
  familias: Familia[] = [];
  familiaSelecionada;

  categorias: Categoria[] = [];
  categoriaSelecionada: any;

  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  public config: PerfectScrollbarConfigInterface = {};
  selectedFile: File;
  nomeArquivoBanco = '';
  arquivo: any;
  tipo: number;
  usarFornecedores = false;
  fornecedores: Fornecedor[] = [];
  fornecedorSelecionado;
  situacoes = [
    { id: 'A', descricao: 'Ativo' },
    { id: 'B', descricao: 'Bloqueado' }
  ];
  situacaoSelecionada = 'A';

  situacoesForn = [
    { id: 'T', descricao: 'Todos' },
    { id: 'A', descricao: 'Ativo' },
    { id: 'B', descricao: 'Bloqueado' }
  ];
  situacaoFornSelecionada = 'A';

  textoOrigemTitulo = '';

  pCentroDistribuicao = false;
  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private pedidoAnexoService: PedidoAnexoService,
    private enumService: EnumService,
    private fornecedorService: FornecedorService,
    private router: Router,
    private viaCepService: ViaCepService,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    public dialogRef: MatDialogRef<AtualizarProdutosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arquivoService: ArquivoService,
    private produtoService: ProdutoService,
    private premissasService: PremissasService,
    private categoriaService: CategoriaService
  ) {
    this.tipo = data.tipo;
    this.usarFornecedores = data.usarFornecedores;
  }

  ngOnInit() {
    if (this.usarFornecedores) {
      this.buscarFornecedores();
    }

    this.buscarFamilias();
    this.buscarCategorias();
    this.buscarPremissaCentroDeDistribuicao();
  }

  buscarCategorias() {
    this.carregandoService.mostra('buscarCategorias');
    this.categoriaService.listar().subscribe(
      (categorias) => {
        this.categorias = categorias;
        this.carregandoService.esconde('buscarCategorias');
      },
      (erro) => {
        this.carregandoService.esconde('buscarCategorias');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (f) => {
        this.pCentroDistribuicao = f.valor;

        this.textoOrigemTitulo = this.usarFornecedores ? 'Fornecedores' : '';
        this.textoOrigemTitulo = this.pCentroDistribuicao ? 'Centro de Distribuição' : '';

        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarFamilias() {
    this.carregandoService.mostra('buscarFamilias');

    this.produtoService.consultarFamilias().subscribe(
      (famis) => {
        this.familias = famis;

        if (this.familias.length > 0) {
          const excetoKit = new Familia();
          excetoKit.idFamilia = 0;
          excetoKit.descricao = 'Exceto Kit';
          this.familias.unshift(excetoKit);
        }

        this.carregandoService.esconde('buscarFamilias');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFamilias');
        this.notificacaoService.erro(erro);
      }
    );
  }

  atualizaDadosPedidoAnexo() {
    this.carregando = false;

    this.carregandoService.esconde('buscaPedidoAnexo');
  }

  salvar() {
    this.carregandoService.mostra('salvaPedidoAnexo');

    const dados = new FormData();
    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('arqui[arquivo]', this.selectedFile.name);
    } else {
      dados.append('arqui[arquivo]', this.arquivo);
    }

    this.pedidoAnexoService.salvar(dados).subscribe(
      () => {
        this.notificacaoService.sucesso('Produtos atualizados com sucesso!!!');
        this.carregandoService.esconde('salvaPedidoAnexo');
        this.dialogRef.close(true);
      },
      (erro) => {
        this.carregandoService.esconde('salvaPedidoAnexo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ngOnDestroy(): void {}

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.arquivo = '';
  }

  baixarArquivo() {
    this.carregandoService.mostra('baixarArquivo');

    let nomeForn;

    if (this.usarFornecedores) {
      nomeForn = this.fornecedores.find((p) => p.id == this.fornecedorSelecionado).descricao;
    }

    if (this.tipo === 0) {
      this.produtoService
        .exportarEstoque(
          this.situacaoSelecionada,
          this.fornecedorSelecionado,
          this.familiaSelecionada,
          this.categoriaSelecionada
        )
        .subscribe(
          (arq) => {
            this.utilitarioService.saveBlob(
              arq,
              this.usarFornecedores ? 'EstoqueProdutos_' + nomeForn + '.xlsx' : 'EstoqueProdutos.xlsx'
            );
            this.carregandoService.esconde('baixarArquivo');
          },
          (erro) => {
            this.carregandoService.esconde('baixarArquivo');
            this.notificacaoService.erro(erro);
          }
        );
    } else {
      // tipo 1 = valores
      this.produtoService
        .exportarValores(
          this.situacaoSelecionada,
          this.fornecedorSelecionado,
          this.familiaSelecionada,
          this.categoriaSelecionada,
          this.situacaoFornSelecionada
        )
        .subscribe(
          (arq) => {
            this.utilitarioService.saveBlob(
              arq,
              this.usarFornecedores ? 'ValoresEstoqueProdutos_' + nomeForn + '.xlsx' : 'ValoresProdutos.xlsx'
            );
            this.carregandoService.esconde('baixarArquivo');
          },
          (erro) => {
            this.carregandoService.esconde('baixarArquivo');
            this.notificacaoService.erro(erro);
          }
        );
    }
  }

  importarArquivo() {
    const dados = new FormData();
    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('importarArquivo');
    if (this.tipo === 0) {
      this.produtoService.importarEstoque(dados, this.fornecedorSelecionado).subscribe(
        (resp) => {
          this.carregandoService.esconde('importarArquivo');
          this.notificacaoService.sucesso('Estoque dos produtos importado com sucesso!!!');
          this.dialogRef.close(true);
        },
        (erro) => {
          this.carregandoService.esconde('importarArquivo');
          this.notificacaoService.erro(erro);
        }
      );
    } else {
      this.produtoService.importarValores(dados, this.fornecedorSelecionado).subscribe(
        (resp) => {
          this.carregandoService.esconde('importarArquivo');
          // Quando um fornecedor é informado, a importação roda em segundo plano
          // (job assíncrono) — a resposta aqui só confirma que o arquivo foi
          // recebido e enfileirado, não que a importação já terminou.
          const mensagem =
            this.fornecedorSelecionado === null || this.fornecedorSelecionado === undefined
              ? 'Valores dos produtos importado com sucesso!!!'
              : 'Arquivo recebido! A importação foi enfileirada e será processada em segundo plano. Você será notificado quando for concluída.';
          this.notificacaoService.sucesso(mensagem);
          this.dialogRef.close(true);
        },
        (erro) => {
          this.carregandoService.esconde('importarArquivo');
          this.notificacaoService.erro(erro);
        }
      );
    }
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forns) => {
        this.fornecedores = forns.filter((f) => f.descricao != null && f.descricao.trim() != '');

        if (this.fornecedores.length > 0) {
          const todos = new Fornecedor();
          todos.id = 0;
          todos.descricao = 'TODOS';
          this.fornecedores.push(todos);
        }

        this.carregandoService.esconde('buscarFornecedores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  desabilitarBotaoBaixarModelo(): boolean {
    return (
      this.usarFornecedores &&
      (this.fornecedorSelecionado === null ||
        this.fornecedorSelecionado === undefined ||
        (!this.cdEspecificoSelecionado() &&
          (this.familiaSelecionada === null || this.familiaSelecionada === undefined)))
    );
  }

  cdEspecificoSelecionado(): boolean {
    return (
      this.pCentroDistribuicao &&
      this.fornecedorSelecionado !== null &&
      this.fornecedorSelecionado !== undefined &&
      this.fornecedorSelecionado !== 0
    );
  }
}
